<template>
    <header>

    <nav class="bg-white border-gray-200 px-4 lg:px-6 py-2.5">
      <div class="flex flex-wrap justify-between items-center mx-auto max-w-screen-xl">
        <router-link to="/" class="flex items-center">
          <img class="h-10 mr-4 lg:h-11" src="@/assets/logo.png" />
        </router-link>

      <div class="flex flex-row">
        <a href="#projects"
                class="py-2 px-4 text-gray-700 hover:bg-gray-50 lg:hover:bg-transparent lg:hover:text-primary-700">Projects</a>
     
                <a href="#apply"
                class="p-2 px-4 text-gray-700 hover:bg-gray-50 lg:hover:bg-transparent lg:hover:text-primary-700">Apply</a>
      </div>
        <!--
        <div class="flex items-center lg:order-2 ml-auto">
          <button @click="isOpen = !isOpen" type="button"
            class="inline-flex items-center p-2 ml-1 text-sm text-gray-500 rounded-lg lg:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
            aria-controls="mobile-menu-2" aria-expanded="false">
            <span class="sr-only">Open main menu</span>
            <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd"
                d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                clip-rule="evenodd"></path>
            </svg>
            <svg class="hidden w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clip-rule="evenodd"></path>
            </svg>
          </button>
        </div>
        <div v-if="isOpen" class="absolute justify-between items-center w-full lg:flex lg:w-auto lg:order-1 bg-white top-40 z-50 -ml-4" id="mobile-menu-2">
          <ul class="flex flex-col font-medium lg:flex-row lg:space-x-8 lg:mt-0 m-1 rounded-sm">
            <li>
              <router-link to="/"
                class="block py-2 pr-4 pl-6 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary-700 lg:p-0 dark:text-gray-400 lg:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white lg:dark:hover:bg-transparent dark:border-gray-700">Ana Sayfa</router-link>
            </li>
            <li>
              <router-link to="/okul/demo"
                class="block py-2 pr-4 pl-6 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary-700 lg:p-0 dark:text-gray-400 lg:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white lg:dark:hover:bg-transparent dark:border-gray-700">Demo</router-link>
            </li>
            <li>
              <router-link to="/teacher-list"
                class="block py-2 pr-4 pl-6 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary-700 lg:p-0 dark:text-gray-400 lg:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white lg:dark:hover:bg-transparent dark:border-gray-700">Öğretmenler</router-link>
            </li>
          </ul>
        </div>

       
         <div
          :class="{'hidden lg:flex': true, 'absolute top-full left-0 w-full bg-white lg:hidden': isOpen}" 
          id="mobile-menu-2">
          <ul class="flex flex-col lg:flex-row mt-4 lg:mt-0 font-medium lg:space-x-8">
            <li>
               <router-link to="/"
                class="block py-2 pr-4 pl-3 text-white rounded bg-primary-700 lg:bg-transparent lg:text-primary-700 lg:p-0 dark:text-white"
                aria-current="page">Home</router-link>
            </li>
            <li>
              <router-link to="/"
                class="block py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary-700 lg:p-0 dark:text-gray-400 lg:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white lg:dark:hover:bg-transparent dark:border-gray-700">Ana Sayfa</router-link>
            </li>
            <li>
              <router-link to="/okul/demo"
                class="block py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary-700 lg:p-0 dark:text-gray-400 lg:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white lg:dark:hover:bg-transparent dark:border-gray-700">Demo</router-link>
            </li>
            <li>
              <router-link to="/teacher-list"
                class="block py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary-700 lg:p-0 dark:text-gray-400 lg:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white lg:dark:hover:bg-transparent dark:border-gray-700">Öğretmenler</router-link>
            </li>
          </ul>
        </div>
      -->
      </div>
    </nav>
    </header>
  </template>
  
  <script lang="ts">
  import { defineComponent, ref } from 'vue';
  import { useRouter } from 'vue-router';
  import { useAuthStore } from '../stores/auth';
  
  export default defineComponent({
    setup() {
      const authStore = useAuthStore();
      const router = useRouter();
      const isOpen = ref(false);

      const logout = () => {
        authStore.logout();
        router.push('/');
      };

      router.afterEach(() => {
        isOpen.value = false;
      });
  
      return {
        authStore,
        isOpen,
        logout,
      };
    },
  });
  </script>
  
  <style scoped>
html { scroll-behavior: smooth; }
  </style>
  